function cmmGetPath(path: string = ''): string {
	if (path == '') {
		path = window.location.pathname;
	}

	return path[path.length - 1] == '/' ? path.slice(1,-1) : path.substring(1);
}
var strPath = cmmGetPath();

/**
 * 
 */
function cmmUpdateMetadata(pageData) {
	let metadata = pageData[strPath];

	if (metadata) {
		let descMetaTag = null;
		let ogTitle = null;
		let ogDesc = null;
		let ogImage = null;

		let metaTags = document.getElementsByTagName("meta");
		if (metadata.description || metadata.desc || metadata.d || metadata.title || metadata.t) {
			for (let i = 0; i < metaTags.length; i++) {

				if (metaTags[i].name == "description") {
					descMetaTag = metaTags[i];
				}

				let metaProperty = metaTags[i].getAttribute('property')
				if (!metaProperty) metaProperty = '';
				if (metaProperty == "og:description") {
					ogDesc = metaTags[i];
				} else if (metaProperty == "og:title") {
					ogTitle = metaTags[i];
				} else if (metaProperty == "og:image") {
					ogImage = metaTags[i];
				}
			}
		}

		if (metadata.description || metadata.desc || metadata.d) {
			if (!descMetaTag) {
				descMetaTag = document.createElement('meta');
				descMetaTag.name = "description";
				document.head.append(descMetaTag);
			}
			descMetaTag.content = metadata.description || metadata.desc || metadata.d;

			if (!ogDesc) {
				ogDesc = document.createElement('meta');
				ogDesc.setAttribute("property", "og:description");
				document.head.append(ogDesc);
			}
			ogDesc.content = metadata.description || metadata.desc || metadata.d;
		}

		if (metadata.title || metadata.t) {
			let titleTag = document.getElementsByTagName("title")[0];
			titleTag.innerText = metadata.title || metadata.t;
			document.title = metadata.title || metadata.t;

			if (!ogTitle) {
				ogTitle = document.createElement('meta');
				ogTitle.setAttribute("property", "og:title");
				document.head.append(ogTitle);
			}
			ogTitle.content = metadata.title || metadata.t;
		}

		if (metadata.image || metadata.i) {
			if (!ogImage) {
				ogImage = document.createElement('meta');
				ogImage.setAttribute("property", "og:image");
				document.head.append(ogImage);
			}
			ogImage.content = metadata.image || metadata.i;
		}
	}
}

function loadScriptCMM(url: string, vars: string, isAsync: boolean = false, callback = null) {
  var script = document.createElement("script");

  var args = "";
  if (typeof vars !== 'undefined' && vars != "") {
    args = "?" + vars;
  }

  if (callback) {
	script.onload = function(){
      callback();
	};
  }

  script.src = url + args;
  if (isAsync) script.async = isAsync;
  document.head.appendChild(script);
}
if ((window as any).siteCMMBizID && !(window as any).loadScriptGTM && window.location.hostname != 'my.duda.co') {
  loadScriptCMM("//assets.creekmoremarketing.com/" + (window as any).siteCMMBizID.trim() + "/main.min.js", "", false);
}